import React from "react";
import styled from "styled-components";

import { Footer, Container, TestMode, Flex, Logo } from "../../components";
import { COLOR } from "../../components/theme";
import { envConfig } from "../../core/config";
import { ENVIRONMENT } from "../../core/constants";
import { AppMessage, APP_MESSAGE_AREA } from "../shared";

const StyledWrapper = styled.div`
  display: grid;
  grid-template-areas:
    "header"
    "content"
    "footer";

  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  height: 100vh;
  background-color: ${COLOR.WHITE};

  li::before {
    background-color: ${COLOR.MID_GREY};
    width: 0.3em;
    height: 0.3em;
  }
`;

const StyledHeader = styled.header`
  grid-area: header;
`;

const StyledMain = styled.main`
  grid-area: content;
`;

const StyledFooter = styled.footer`
  grid-area: footer;
`;

const StyledMerchantLogo = styled.img`
  height: 30px;
  max-width: 220px;
`;

const Scene = ({ merchantLogoURL, country, theme, children }) => (
  <StyledWrapper>
    <StyledHeader>
      <Container
        bg="white"
        color={theme?.fontColor}
        fullWidth
        lightBorderBottom
      >
        <Container maxWidth="1080" gutters>
          <Flex padding="15px 0">
            {/* only show header when logo url is defined */}
            {Boolean(merchantLogoURL) && (
              <Header
                merchantLogoURL={merchantLogoURL}
                variant={theme?.bgColor}
              />
            )}
          </Flex>
        </Container>
      </Container>
    </StyledHeader>

    <StyledMain>
      <AppMessage area={APP_MESSAGE_AREA.CHECKOUT} />

      {envConfig !== ENVIRONMENT.PROD && <TestMode />}

      {children}
    </StyledMain>

    {/* only show footer when logo url is defined */}
    {Boolean(merchantLogoURL) && (
      <StyledFooter>
        <Footer
          bg={theme?.bgColor ?? "white"}
          fontColor={theme?.fontColor}
          variant={theme?.variant}
          country={country}
        />
      </StyledFooter>
    )}
  </StyledWrapper>
);

const Header = ({ merchantLogoURL, variant }) => {
  if (merchantLogoURL) {
    return (
      <>
        <StyledMerchantLogo src={merchantLogoURL} alt="merchant-logo" />
        <Logo mini variant={variant} />
      </>
    );
  }

  return null;
};

export default Scene;
